import { Injectable } from '@angular/core';
import {
  Resolve,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { BaseService } from '@kodit/core/services';
import { UlaznaFakturaDto, UlazneFaktureClient } from '@kodit/core/data-api';
import { Observable } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class UlaznaFakturaDuplikatResolver
  extends BaseService
  implements Resolve<UlaznaFakturaDto> {
  constructor(private _client: UlazneFaktureClient, private _router: Router) {
    super();
  }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<UlaznaFakturaDto>
    | Promise<UlaznaFakturaDto>
    | UlaznaFakturaDto
    | null {
    let id = 0;
    try {
      id = this._router.getCurrentNavigation().extras.state.id;
    } catch {
      return null;
    }

    return this._client.duplicateUlaznaFaktura(id).pipe(
      map((res) => res.data),
      catchError(this.handleError),
      finalize(() => {
        //this._configService.setIsBusy = false;
      })
    );
  }
}
